/**
 * Main
 *
 * The main file, page logic which is needed on all pages will be included here.
 * Please note for specific components like a slider create a separated components/<component_name>.js
 * The components will be loaded through the component loader and are not needed on every page!
 */
import MmenuLight from 'mmenu-light';
document.addEventListener('DOMContentLoaded', () => {
  $('.js-toggle-menu').click(function (e) {
    e.preventDefault();
    $(this).toggleClass('is-active');
    $('html, body').toggleClass('mm-ocd-opened');
    $('.header__main-menu').toggleClass('header__main-menu--open');
  });
  $('.header__menu > ul > li > ul').parent('li').addClass('has-children');
  $('.has-children > a').click(function (e) {
    e.preventDefault(); // hide all span

    var $this = $(this).next('ul');
    $('.has-children ul').not($this).slideUp();

    if (!$(this).parent().hasClass('is-active')) {
      $('.has-children').removeClass('is-active');
      $(this).parent().addClass('is-active');
      $(this).next('ul').slideDown();
    } else {
      $(this).parent().removeClass('is-active');
      $(this).next('ul').slideUp();
    }
  });
  $('a[href="#top"]').on('click', function (event) {
    event.preventDefault();
    $('html, body').animate({
      scrollTop: 0
    });
  });
});